(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cb-article-contents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-guide-contents')) {
    customElements.define(
      'cb-guide-contents',
      class extends HTMLElement {
        connectedCallback() {
          this.article = this.closest('.cb-article');
          if (!this.article) return;
          this.build();
          // Rebuild when headings are added, removed or edited (theme editor).
          const main = this.article.querySelector('.cb-article__main');
          if (main) {
            this.observer = new MutationObserver(() => this.build());
            this.observer.observe(main, { childList: true, subtree: true, characterData: true });
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        build() {
          const list = this.querySelector('ul');
          const headings = [...this.article.querySelectorAll('.cb-article__main > .cb-heading')].filter((h) => h.id);
          if (this.hasAttribute('data-skip-first')) headings.shift();
          const signature = headings.map((h) => h.id + h.textContent).join('|');
          if (signature === this.signature) return;
          this.signature = signature;
          list.replaceChildren(
            ...headings.map((h) => {
              const item = document.createElement('li');
              const link = document.createElement('a');
              link.href = '#' + h.id;
              link.textContent = h.textContent.trim();
              item.append(link);
              return item;
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
